import './../../../node_modules/react-grid-layout/css/styles.css';
import './../../../node_modules/react-resizable/css/styles.css';
import './custom.css';

import React, {Component} from 'react';
import {getSlidersList, dndSlider, removeSliderItem} from '../../modules/Api';
import {Col, Card, Button, notification} from 'antd';
import {END_POINT} from '../../constants/config';
import history from '../../modules/History';
import { Responsive as ResponsiveGridLayout } from 'react-grid-layout';

import ACL from '../../components/ACL';

class Sliders extends Component {
    constructor() {
        super();
        this.state = {
            items: []
        }
    }
    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        const appSliderQuery = this.props.appSlider ? 'app_slider=1&' : '';
        const query = appSliderQuery + this.props.location.search.replace('?', '');

        getSlidersList(query, (items) => {
            this.setState({items});
        });
    }
    onDragStop = (layout, oldItem, newItem, placeholder, e, element) => {
        dndSlider(layout.sort((a, b) => b.y + a.y));
    }

    remove = (e,id) => {
        notification.open({
            message: `صبر کنید`,
        });
        removeSliderItem(id, () => {
            this.fetchData();
        })

    }

    getAddRouteParams() {
        return {
            pathname: this.props.appSlider ? '/app-sliders/add' : '/sliders/add',
            search: this.props.location.search,
        }
    }

    render() {
        const items = this.state.items;

        const title = {
            0: 'موبایل',
            1: 'دسکتاپ',
            2: 'قرعه کشی',
            3: 'برند',
            4: 'تکی',
            6:'اپ موبایل با لینک خارجی'
        };

        return (
            <div style={{direction: 'ltr'}}>
                <div class="btn-container">
                    <ACL component="span" has_permission="sliders_management|sliders_history"><Button type="secondary" onClick={() => history.item.push(`/history/slider`)}>تاریخچه</Button></ACL>
                    <ACL component="span" has_permission="sliders_management|sliders_add"><Button type="primary" onClick={() => history.item.push(this.getAddRouteParams())}>
                        افزودن
                    </Button>
                    </ACL>
                </div>

                <Col span={20} offset={2}>
                    {Object.keys(items).map((key, i) => {
                        return (
                            <Card  key={i} bodyStyle={{overflowX:'auto'}}
                                title={title[parseInt(key, 10)]}
                            >
                                {this.state.items[key].sort((a, b) => a.order - b.order).map((pop, c) => {
                                    const gridStyle = {
                                        width: '100%',
                                        textAlign: 'center',
                                        cursor: 'move',
                                        float: 'center',
                                    };
                                    const removeStyle = {
                                        position: 'absolute',
                                        right: '10px',
                                        top: '10px',
                                        fontSize: '20px',
                                        cursor: 'pointer',
                                        padding:'0 7px',
                                        background: '#ddd'
                                    };
                                    return (
                                        <div key={pop.id} data-key={pop.id} data-grid={{x: 1, y: 0, w: 3, h: 2}}>
                                                <Card style={gridStyle} type="inner">
                                                <ACL component="span" has_permission="sliders_management|sliders_delete"><span style={removeStyle} onClick={(e) => this.remove(e, pop.id)}>&times;</span></ACL>
                                                {
                                                    pop.photo
                                                    &&
                                                    <img
                                                        style={{width:'110px',marginRight:'20px'}}
                                                        src={`${pop.photo.includes('http') ? pop.photo : END_POINT + pop.photo}`}
                                                        alt={pop.alt}

                                                    />
                                                }
                                            </Card>
                                        </div>
                                    );
                                })}
                            </Card>
                        );
                    })}
                </Col>
            </div>
        );
    }
}

export default Sliders;


// WEBPACK FOOTER //
// ./src/containers/Sliders/index.js